<template>
  <div class="box">
    <el-card class="query-card">
      <el-form :model="queryFormParams" ref="queryForm" :rules="rules"  size="small" inline>
        <el-row type="flex" justify="space-around">
          <el-col :span="8">
            <el-form-item :label="$t('findManagers.roleNameInChinese')" prop="roleNameCn">
              <div class="input-with-more">
                <el-input v-model="queryFormParams.roleNameCn" clearable class="full-width" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('findManagers.roleName')" prop="roleNameEn">
              <div class="input-with-more">
                <el-input v-model="queryFormParams.roleNameEn" clearable class="full-width" />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="6">
            <el-form-item>
              <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
              <el-button @click="handleReset">{{ $t('reset') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div class="action-toolbar">
      <el-button v-if="hasPermission('role/findRoles', 'button_add')" @click="handleAdd" type="primary"
        icon="el-icon-plus">
        {{ $t('findManagers.add') }}
      </el-button>
      <el-button v-if="hasPermission('role/findRoles', 'button_update')" @click="handleEdit" type="success"
        icon="el-icon-edit">
        {{ $t('findManagers.modify') }}
      </el-button>
      <el-button v-if="hasPermission('role/findRoles', 'button_del')" @click="handleDelete" type="danger"
        icon="el-icon-delete">
        {{ $t('findManagers.delete') }}
      </el-button>
      <el-button v-if="hasPermission('role/findRoles', 'button_setPer')" @click="handleSetPer" type="info" icon="el-icon-setting">
        {{ $t('findManagers.websitePermissions') }}
      </el-button>
    </div>
    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" @sort-change="handleSortChange" border style="width: 100%" v-loading="loading"
        show-overflow-tooltip :cell-style="{ whiteSpace: 'nowrap' }" :header-cell-style="{ whiteSpace: 'nowrap' }">
        <el-table-column :min-width="columnWidths.select" align="center" :label="$t('findManagers.select')">
          <template slot-scope="scope">
            <el-radio v-if="scope.row.mrRoleType === '1'" v-model="selectedRowId" :label="scope.row.mrId"
              @change="handleRadioChange(scope.row)">
              {{ '' }}
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="mrId" :label="$t('findManagers.id')" :min-width="columnWidths.id" sortable="custom"></el-table-column>
        <el-table-column prop="mrRoleNameCn" :label="$t('findManagers.roleNameInChinese')" :min-width="columnWidths.roleNameInChinese"
          sortable="custom"></el-table-column>
        <el-table-column prop="mrRoleNameEn" :label="$t('findManagers.roleName')" :min-width="columnWidths.roleName"
          sortable="custom"></el-table-column>
        <el-table-column prop="mrIsDisplayed" :label="$t('findManagers.whetherToDisplayAccountDynamic')"
          :min-width="columnWidths.whetherToDisplayAccountDynamic" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.mrIsDisplayed == 1 ? $t('findManagers.yes') :
              scope.row.mrIsDisplayed == 0 ? $t('findManagers.no') : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="mrRemark" :label="$t('findManagers.roleDescription')" :min-width="columnWidths.roleDescription" :show-overflow-tooltip="true"></el-table-column>
      </el-table>

      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.page" :page-sizes="pageSize" :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"
        style="margin-top: 16px; text-align: right;" />
    </el-card>

    <!-- 新增修改弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" @close="close">
      <el-form :model="form" ref="form" :rules="rules" status-icon>
        <el-form-item :label="$t('findManagers.roleNameInChinese')" :label-width="formLabelWidth" prop="mrRoleNameCn">
          <el-input v-model="form.mrRoleNameCn" :placeholder="$t('findManagers.pleaseEnterTheChineseRoleName')"
            clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('findManagers.roleName')" :label-width="formLabelWidth" prop="mrRoleNameEn">
          <el-input v-model="form.mrRoleNameEn" :placeholder="$t('findManagers.pleaseEnterTheEnglishRoleName')"
            clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('findManagers.whetherToDisplayAccountDynamic')" :label-width="formLabelWidth">
          <el-radio v-model="form.mrIsDisplayed" :label="1">{{ $t('findManagers.yes') }}</el-radio>
          <el-radio v-model="form.mrIsDisplayed" :label="0">{{ $t('findManagers.no') }}</el-radio>
          <i class="el-icon-warning-outline"></i> {{ $t('findManagers.pleaseSelect') }}
        </el-form-item>
        <el-form-item :label="$t('findManagers.roleDescription')" :label-width="formLabelWidth">
          <el-input v-model="form.remark" type="textarea" :rows="2"
            :placeholder="$t('findManagers.pleaseEnterARoleDescription')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('findManagers.rolePermissions')" :label-width="formLabelWidth">
          <!-- 外部全选复选框 -->
          <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">
            {{ $t('findManagers.rolePermissionsOptions') }}
          </el-checkbox>
          <el-tree ref="tree" :data="menuData" :props="props" node-key="id" show-checkbox @check="handleTreeCheck"
            :default-expanded-keys="expandedKeys">
          </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">{{ $t('findManagers.cancel') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('submit') }}</el-button>
      </div>
    </el-dialog>
    <!-- 删除对话框 -->
    <el-dialog :title="$t('findManagers.delete')" :visible.sync="deleteDialogVisible" width="30%">
      <span>{{ $t('findManagers.areYouSureToDeleteIt') }}?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">{{ $t('findManagers.cancel') }}</el-button>
        <el-button type="primary" @click="confirmDelete">{{ $t('submit') }}</el-button>
      </span>
    </el-dialog>


    <!-- 网站权限配置弹窗 -->
    <el-dialog :title="$t('findManagers.websitePermissions')" :visible.sync="websiteDialogVisible" width="800px" @close="closeWebsiteDialog">
      <div v-loading="websiteLoading">
        <el-alert
            v-if="!selectedRowId"
            :title="$t('findManagers.pleaseSelectSRecord')"
            type="warning"
            show-icon
            :closable="false"
            style="margin-bottom: 16px;">
        </el-alert>

        <el-table
            v-else
            :data="websiteList"
            border
            style="width: 100%"
            max-height="500">
          <el-table-column prop="wlId" label="ID" width="80" align="center"></el-table-column>
          <el-table-column prop="wlWebsite" :label="$t('findManagers.websiteName')" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('findManagers.status')" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isBound ? 'success' : 'info'" size="small">
                {{ scope.row.isBound ? $t('findManagers.bound') : $t('findManagers.unbound') }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column :label="$t('findManagers.operation')" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                  v-if="!scope.row.isBound"
                  type="primary"
                  size="mini"
                  @click="handleBindWebsite(scope.row)">
                {{ $t('findManagers.bind') }}
              </el-button>
              <el-button
                  v-else
                  type="danger"
                  size="mini"
                  @click="handleUnbindWebsite(scope.row)">
                {{ $t('findManagers.unbind') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="websiteDialogVisible = false">{{ $t('findManagers.close') }}</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import { hasPermission } from "@/utils/permission";
export default {
  name: "findRoles",
  data() {
    const regexCn = /^[\w\u4e00-\u9fa5]+$/;//
    const regexEn = /^[A-Za-z0-9_]+$/;//必须由数字、字母或者下划线组成
    const validateNameCn = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('findManagers.pleaseEnterTheChineseRoleName')));
      } else if (!regexCn.test(value)) {
        callback(new Error(this.$t('findManagers.CnNameRule')));
      } else {
        callback();
      }
    };
    const validateNameEn = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('findManagers.pleaseEnterTheEnglishRoleName')));
      } else if (!regexEn.test(value)) {
        callback(new Error(this.$t('findManagers.EnNameRule')));
      } else {
        callback();
      }
    };
    return {
      queryFormParams: {
        sortField: undefined,
        sortOrder: undefined,
        roleNameCn: "",
        roleNameEn: ""
      },
      tableData: [],
      selectedRowId: "",
      selectedRowData: "", // 当前行全部数据
      loading: false,
      pagination: {
        page: 1,
        limit: 0,
        total: 0,
      },
      // 网站权限
      websiteDialogVisible: false,
      websiteLoading: false,
      websiteList: [], // 存储 wlId, wlWebsite, isBound(是否已绑定)

      pageSize: [10, 20, 50],
      dialogTitle: "",
      dialogFormVisible: false,
      formLabelWidth: '140px',
      form: {
        mrId: null,
        mrRoleNameCn: "",
        mrRoleNameEn: "",
        mrIsDisplayed: 1,
        remark: "",
      },
      rules: {
        mrRoleNameCn: [
          { required: true, validator: validateNameCn, trigger: 'blur' }
        ],
        mrRoleNameEn: [
          { required: true, validator: validateNameEn, trigger: 'blur' }
        ]
      },
      props: {
        children: 'children',
        label: 'label',
      },
      menuData: [],
      checkAll: false,      // 全选复选框的值
      isIndeterminate: false, // 半选状态
      expandedKeys: [],
      currentOperation: "",
      deleteDialogVisible: false,
      columnWidths: {},
    }
  },
  created() {
    this.pagination.limit = this.pageSize[0];
    this.handleSearch(); // 初始化加载数据
  },
  mounted() {
    this.$nextTick(() => {
      this.initColumnWidths();
    });
  },
  methods: {
    hasPermission,
    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.queryMerlistPage();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();
    },
    async queryMerlistPage() {
      this.loading = true;
      try {
        const params = {
          mrRoleNameCn: this.queryFormParams.roleNameCn || undefined,
          mrRoleNameEn: this.queryFormParams.roleNameEn || undefined,
          page: this.pagination.page,
          limit: this.pagination.limit,
          sortField: this.queryFormParams.sortField,
          sortOrder: this.queryFormParams.sortOrder,
        };

        const res = await this.$axios.post('/api/role/merlist', params);
        if (res.data.code === 0) {
          const responseData = res.data.data;

          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }

      } catch (err) {
        this.$message.error(this.$t('requestFailed'));
        this.tableData = [];
        this.pagination.total = 0;
      } finally { this.loading = false; }
    },
    //打开新增弹窗
    handleAdd() {
      this.dialogTitle = this.$t('findManagers.add');
      this.currentOperation = 'add';
      this.dialogFormVisible = true;
      //获取角色权限数据
      this.queryMenuTree();
    },
    //打开修改弹窗
    async handleEdit() {
      if (this.selectedRowId == null || this.selectedRowId == "") {
        this.$message.warning(this.$t('findManagers.pleaseSelectSRecord') + '!');
        return
      }
      this.dialogTitle = this.$t('findManagers.modify');
      this.currentOperation = 'edit';
      this.dialogFormVisible = true;
      //获取角色权限数据
      await this.queryMenuTree();
      //获取选中角色拥有的权限
      this.queryRoleInfoById();
    },
    //打开删除窗
    handleDelete() {
      if (this.selectedRowId == null || this.selectedRowId == "") {
        this.$message.warning(this.$t('findManagers.pleaseSelectSRecord') + '!');
        return
      }
      this.deleteDialogVisible = true;
    },
    // 获取商户的来源网站集合
    async handleSetPer(){

      this.websiteDialogVisible = true;
      this.websiteLoading = true;
      this.websiteList = [];

      try {
        const res = await this.$axios.get("/api/role/getWebsites");
        if(res.data.code === 0){
          const responseData = res.data.data;

        }else {
          // 弹窗提示没有数据

        }
      }catch (e){
        console.error(e);
      }

    },
    //处理选中行
    handleRadioChange(row) {
      this.selectedRowData = row;
    },
    //处理排序
    handleSortChange({ column, prop, order }) {
      if (order) {
        this.queryFormParams.sortField = prop;
        this.queryFormParams.sortOrder = order === 'ascending' ? 'asc' : 'desc';
      } else {
        // 取消排序时，清空排序参数
        this.queryFormParams.sortField = null;
        this.queryFormParams.sortOrder = null;
      }
      this.queryMerlistPage();

    },
    //分页变化查询
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1;
      this.queryMerlistPage();
    },
    //分页变化查询
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.queryMerlistPage();
    },
    //查询菜单权限
    async queryMenuTree() {
      try {
        const res = await this.$axios.get('/api/modules/menuTree')
        if (res.data.code === 0) {
          //递归整理树形数据
          this.menuData = this.handledata(res.data.data);
        } else {
          this.$message.error(res.data.msg);
        }
      } catch (err) {
        console.log(err);
        this.$message.error(this.$t('requestFailed'));
      }

    },
    handledata(datas) {
      // 返回一个新数组，包含所有转换后的节点
      const result = [];
      for (const item of datas) {
        // 构建当前节点
        const newNode = {
          id: item.id,
          label: item.names[this.$i18n.locale],
          children: []
        };
        // 如果 children 存在且是非空数组，则递归处理
        if (item.children && Array.isArray(item.children) && item.children.length > 0) {
          newNode.children = this.handledata(item.children);
        }
        result.push(newNode);
      }
      return result;
    },
    // 全选复选框变化
    handleCheckAllChange(val) {
      // 获取所有根节点（树的 data 数组）
      const rootNodes = this.menuData;
      // 提取根节点的 id
      const rootKeys = rootNodes.map(node => node.id);
      if (val) {
        // 全选：勾选所有根节点（子节点自动联动勾选）
        this.$refs.tree.setCheckedKeys(rootKeys);
      } else {
        // 全不选：清空所有勾选
        this.$refs.tree.setCheckedKeys([]);
      }
      // 更新外部复选框状态（其实树事件会触发更新，但这里主动调用一次确保同步）
      this.updateCheckAllState();
    },
    // 树节点勾选变化时触发
    handleTreeCheck() {
      this.updateCheckAllState();
    },

    // 更新外部全选复选框的状态
    updateCheckAllState() {
      const checkedKeys = this.$refs.tree.getCheckedKeys();
      const allKeys = this.getAllNodeKeys(this.menuData);
      const checkedCount = checkedKeys.length;
      const totalCount = allKeys.length;

      if (checkedCount === 0) {
        this.checkAll = false;
        this.isIndeterminate = false;
      } else if (checkedCount === totalCount) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else {
        this.checkAll = false;
        this.isIndeterminate = true;
      }
    },

    // 递归获取所有节点的 key
    getAllNodeKeys(nodes) {
      let keys = [];
      nodes.forEach(node => {
        keys.push(node.id);
        if (node.children && node.children.length) {
          keys = keys.concat(this.getAllNodeKeys(node.children));
        }
      });
      return keys;
    },
    //获取角色权限信息
    async queryRoleInfoById() {
      const mrmmMrId = this.selectedRowId;
      try {
        const res = await this.$axios.get(`/api/role/info/${mrmmMrId}`);
        if (res.data.code === 0) {
          //返显选中行值
          this.form.mrId = res.data.data.role.mrId;
          this.form.mrRoleNameCn = res.data.data.role.mrRoleNameCn;
          this.form.mrRoleNameEn = res.data.data.role.mrRoleNameEn;
          this.form.mrIsDisplayed = Number(res.data.data.role.mrIsDisplayed);
          this.form.remark = res.data.data.role.mrRemark;
          const checkedIds = res.data.data.roleModuleList;
          const expandedKeys = this.getAncestorKeys(this.menuData, checkedIds);
          this.expandedKeys = expandedKeys;  // 直接赋值，树会自动展开
          // 在数据渲染完成后设置勾选（用 $nextTick 确保树已渲染）
          this.$nextTick(() => {
            const allIdsFromBackend = checkedIds;
            const leafIds = [];
            allIdsFromBackend.forEach(id => {
              // 获取节点对象
              const node = this.$refs.tree.getNode(id);
              // 如果是叶子节点，放入数组
              if (node && node.isLeaf) {
                leafIds.push(id);
              }
            });

            // 设置叶子节点选中，这会自动更新大部分父节点状态
            this.$refs.tree.setCheckedKeys(leafIds);

          });
        } else {
          this.$message.error(res.data.msg);
        }
      } catch (err) {
        console.error(err);
        this.$message.error(this.$t('requestFailed'));
      }
    },
    //取消，清空表单数据
    close() {
      this.dialogFormVisible = false;
      this.form = {
        mrId: null,
        mrRoleNameCn: "",
        mrRoleNameEn: "",
        mrIsDisplayed: 1,
        remark: "",
      };
      // 清除校验状态
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
      //清空权限数据
      this.$refs.tree.setCheckedKeys([]);
    },
    //默认展开设置
    getAncestorKeys(treeData, targetIds) {
      const result = new Set();
      const dfs = (nodes, path) => {
        for (const node of nodes) {
          const currentPath = [...path, node.id];
          if (targetIds.includes(node.id)) {
            // 当前节点是目标节点，将其所有祖先加入结果（不包括自身）
            currentPath.slice(0, -1).forEach(id => result.add(id));
          }
          if (node.children) {
            dfs(node.children, currentPath);
          }
        }
      };
      dfs(treeData, []);
      return Array.from(result);
    },
    submit() {
      //新增
      if (this.currentOperation === 'add') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            // 1. 获取所有完全选中的节点 ID（包括父节点和所有子节点）
            const checkedKeys = this.$refs.tree.getCheckedKeys();
            // 2. 获取所有半选中的父节点 ID（部分子节点被选中的父节点）
            const halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys();
            // 3. 合并并去重，得到最终需要提交的 ID 列表
            const allKeys = [...new Set([...checkedKeys, ...halfCheckedKeys])];
            if (allKeys.length === 0) {
              this.$message.error(this.$t('findManagers.pleaseSelecTheRolePermissions'));
              return;
            }
            const params = {
              mrRoleNameCn: this.form.mrRoleNameCn,
              mrRoleNameEn: this.form.mrRoleNameEn,
              mrIsDisplayed: this.form.mrIsDisplayed,
              remark: this.form.remark,
              powerIdList: allKeys
            }
            this.$axios.post('/api/role/add', params)
              .then(res => {
                if (res.data.code === 0) {
                  this.$message.success(res.data.msg);
                  this.close();//关闭弹窗
                  this.queryMerlistPage();//查询刷新数据
                } else {
                  this.$message.error(res.data.msg);
                }
              })
              .catch(error => {
                this.$message.error(this.$t('requestFailed'));
                console.error(error);
              });
          } else {
            return false;
          }
        });

      } else {
        //修改
        this.$refs.form.validate((valid) => {
          if (valid) {
            // 1. 获取所有完全选中的节点 ID（包括父节点和所有子节点）
            const checkedKeys = this.$refs.tree.getCheckedKeys();
            // 2. 获取所有半选中的父节点 ID（部分子节点被选中的父节点）
            const halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys();
            // 3. 合并并去重，得到最终需要提交的 ID 列表
            const allKeys = [...new Set([...checkedKeys, ...halfCheckedKeys])];
            if (allKeys.length === 0) {
              this.$message.error(this.$t('findManagers.pleaseSelecTheRolePermissions'));
              return;
            }
            const params = {
              mrId: this.form.mrId,
              mrRoleNameCn: this.form.mrRoleNameCn,
              mrRoleNameEn: this.form.mrRoleNameEn,
              mrIsDisplayed: this.form.mrIsDisplayed,
              remark: this.form.remark,
              powerIdList: allKeys
            }
            this.$axios.put('/api/role/update', params)
              .then(res => {
                if (res.data.code === 0) {
                  this.$message.success(res.data.msg);
                  this.close();//关闭弹窗
                  this.queryMerlistPage();//查询刷新数据
                } else {
                  this.$message.error(res.data.msg);
                }
              })
              .catch(error => {
                this.$message.error(this.$t('requestFailed'));
                console.error(error);
              });
          } else {
            return false;
          }
        });
      }
    },
    //确认删除
    confirmDelete() {
      const ids = [this.selectedRowId]
      this.$axios.delete('/api/role/delete', { data: ids })
        .then(res => {
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.deleteDialogVisible = false;
            this.queryMerlistPage();//查询刷新数据
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error(this.$t('requestFailed'));
          console.error(error);
        })
    },
    // 表头宽度
    initColumnWidths() {
      const cols = [
        "id",
        "select",
        "roleNameInChinese",
        "roleName",
        "whetherToDisplayAccountDynamic",
        "roleDescription",
      ];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = '14px Helvetica';

      cols.forEach(key => {
        const label = this.$t(
          `findManagers.${key}`
        );

        this.$set(
          this.columnWidths,
          key,
          Math.ceil(ctx.measureText(label).width) + 40
        );
      });
    },
  }
}
</script>

<style scoped>
.box {
  padding: 20px;
}

/* --- 修改 1：美化查询表单的标签字体 --- */
/*.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important;
  !* 强制加粗生效 *!
  color: #303133 !important;
  !* 强制颜色深灰生效 *!
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  min-width: 120px;
  text-align: right;
}*/
.query-card /deep/ .el-form-item {
  display: flex !important;
  align-items: center;
  width: 100%;
  margin-right: 0 !important;
}
.query-card /deep/ .el-form-item__label {
  width: auto !important;          /* 覆盖掉 auto 测量锁死的宽度 */
  flex-shrink: 0;                  /* 关键：标签不被挤压 */
  white-space: nowrap !important;
  font-weight: 600 !important;
  color: #303133 !important;
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  text-align: right;
  /* 注意：删掉了 min-width: 120px，它是测量锁死的帮凶 */
}
.query-card /deep/ .el-form-item__content {
  flex: 1;
  min-width: 0;                    /* 允许输入框收缩，防止撑破列 */
  margin-left: 0 !important;
}
.query-card /deep/ .el-input {
  width: 100%;
}
.query-card /deep/ .btn-item {
  display: block !important;
  text-align: center;
}
.query-card /deep/ .el-form-item__content .el-input {
  width: 100%;
  max-width: 200px;   /* ← 长度开关就在这，想多长改这一个数 */
}


/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important;
  /* 强制生效 */
  color: #606266 !important;
  /* 强制生效 */
  border-radius: 6px !important;
  /* 强制微圆角生效 */
}

/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}

/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;
  /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}

.table-card {
  overflow-x: auto;
}

.table-card ::v-deep .el-table {
  min-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/role/findRoles.vue